module.exports = __webpack_public_path__ + "img/m-wash3prousa-back.6b752e13.jpg";